// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDoh6-Byzwg6n5cLOOq_rO0K7iH9Jecjw0",
  authDomain: "berniescleaningco.firebaseapp.com",
  projectId: "berniescleaningco",
  storageBucket: "berniescleaningco.firebasestorage.app",
  messagingSenderId: "933269087121",
  appId: "1:933269087121:web:508aa5a52387591a9ab030",
  measurementId: "G-7TH6Q3GJRL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);